import { render, staticRenderFns } from "./consultants.vue?vue&type=template&id=dc83b4b6&"
import script from "./consultants.vue?vue&type=script&lang=js&"
export * from "./consultants.vue?vue&type=script&lang=js&"
import style0 from "./consultants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports